<template>
  <div>
    <BreadCrumd :title="'Configuration'" :description="'Dictionnaire'" />
    <div class="mt-4 mb-4">
      <div class="card card-body">
        <table class="table table-striped table-hover table-bordered table-sm">
          <tbody>
            <template v-for="(row, rowIndex) in dictionnaires">
              <tr
                v-for="(menu, index) in row.blocks"
                :key="index + '-' + rowIndex"
              >
                <td>
                  <router-link :to="{ name: menu.route }" class="text-primary">
                    <i class="fas fa-cubes mr-1"></i>{{ menu.libelle }}
                  </router-link>
                </td>
                <td>{{ menu.description }}</td>
              </tr>
              <tr :key="rowIndex">
                <td
                  colspan="2"
                  style="height: 30px !important"
                  v-if="dictionnaires.length - 1 !== rowIndex"
                ></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dictionnaires: [
        {
          blocks: [
            {
              route: 'configuration_dic_civilite',
              libelle: 'Civilités',
              description: 'Gestion des civilités',
            },
            {
              route: 'configuration_dic_genre',
              libelle: 'Genres',
              description: 'Gestion des genres',
            },
            {
              route: 'configuration_dic_langue',
              libelle: 'Langues',
              description: 'Gestion des langues',
            },
            {
              route: 'configuration_dic_mode_reglement',
              libelle: 'Modes de règlement',
              description: 'Gestion des modes de règlement',
            },
            {
              route: 'configuration_dic_condition_reglement',
              libelle: 'Conditions de règlement',
              description: 'Gestion des conditions de règlement',
            },
            {
              route: 'configuration_dic_centre_cout',
              libelle: 'Centres de coût',
              description: 'Gestion des centres de coût',
            },
            {
              route: 'configuration_dic_ligne_budgetaire',
              libelle: 'Lignes budgétaire',
              description: 'Gestion des lignes budgétaire',
            },
            {
              route: 'configuration_dic_devise',
              libelle: 'Devises',
              description: 'Gestion des devises',
            },
            {
              route: 'configuration_dic_priorite',
              libelle: 'Priorités',
              description: 'Gestion des priorités',
            },
          ],
        },
        {
          blocks: [
            {
              route: 'configuration_dic_entrepot',
              libelle: 'Entrepôts',
              description: 'Gestion des entrepôts des articles',
            },
            {
              route: 'configuration_dic_famille',
              libelle: 'Familles',
              description: 'Gestion des familles des articles',
            },
            {
              route: 'configuration_dic_unite',
              libelle: 'Unités',
              description: 'Gestion des unités des articles',
            },
          ],
        },
        {
          blocks: [
            {
              route: '',
              libelle: 'Types de note de frais',
              description:
                'Gestion des types de note de frais pour les notes de frais',
            },
            {
              route: '',
              libelle: 'Fréquences planning',
              description: 'Gestion des fréquences pour les abonnements',
            },
          ],
        },
        {
          blocks: [
            {
              route: 'configuration_dic_cle_param',
              libelle: 'Clés de paramètre',
              description: 'Gestion des clés de paramètre',
            },
            {
              route: 'configuration_dic_type_evenement',
              libelle: "Types d'évènement",
              description: "Gestion des types d'évènement",
            },
          ],
        },
        {
          blocks: [
            {
              route: 'configuration_dic_direction',
              libelle: 'Directions',
              description: 'Gestion des directions',
            },
            {
              route: 'configuration_dic_employe_service',
              libelle: 'Services',
              description: 'Gestion des services pour directions',
            },
            {
              route: 'configuration_dic_employe_societe',
              libelle: 'Societés',
              description: 'Gestion des sociétés pour salariés',
            },
          ],
        },
        {
          blocks: [
            {
              route: 'configuration_dic_profil',
              libelle: 'Profils',
              description: 'Gestion des profils pour les employés',
            },
            {
              route: 'configuration_dic_ccn_statut_categorie',
              libelle: 'Statuts catégoriels CCN',
              description: 'Gestion des statuts catégoriels CCN',
            },
            {
              route: 'configuration_dic_contrat_type',
              libelle: 'Types de contrat',
              description: 'Gestion des types de contrat',
            },
            {
              route: 'configuration_dic_convention_collective',
              libelle: 'Conventions collectives',
              description: 'Gestion des conventions collectives',
            },
            {
              route: 'configuration_dic_emploi_nature',
              libelle: "Natures d'emploi",
              description: "Gestion des natures d'emploi",
            },
            {
              route: 'configuration_dic_expression_temps_travail',
              libelle: 'Expressions de temps de travail',
              description: 'Gestion des expressions de temps de travail',
            },
            {
              route: 'configuration_dic_irc_statut_categorie',
              libelle: 'Statuts catégoriels IRC',
              description: 'Gestion des statuts catégoriels IRC',
            },
            {
              route: 'configuration_dic_lien_parente',
              libelle: 'Liens de parenté',
              description: 'Gestion des liens de parenté',
            },
            {
              route: 'configuration_dic_motif_entree',
              libelle: "Motifs d'entrée",
              description: "Gestion des motifs d'entrée",
            },
            {
              route: 'configuration_dic_salarie_statut',
              libelle: 'Statuts du salarié',
              description: 'Gestion des statuts du salarié',
            },
            {
              route: 'configuration_dic_situation_administrative',
              libelle: 'Situations administratives',
              description: 'Gestion des situations administratives',
            },
            {
              route: 'configuration_dic_situation_familiale',
              libelle: 'Situations familiales',
              description: 'Gestion des situations familiales',
            },
            {
              route: 'configuration_dic_specificite_contrat',
              libelle: 'Spécificités de contrat',
              description: 'Gestion des spécificités de contrat',
            },
          ],
        },
        {
          blocks: [
            {
              route: 'configuration_dic_nature_poste',
              libelle: 'Natures de poste',
              description: 'Gestion des natures de poste',
            },
            {
              route: 'configuration_dic_poste',
              libelle: 'Postes',
              description: 'Gestion des postes',
            },
          ],
        },
        {
          blocks: [
            {
              route: 'configuration_dic_statut_candidature',
              libelle: 'Statuts pour candidature',
              description: 'Gestion des statuts pour candidature',
            },
          ],
        },

        {
          blocks: [
            {
              route: 'configuration_dic_domaine_competence',
              libelle: 'Domaines de compétences',
              description: 'Gestion des domaines de compétence',
            },
            {
              route: 'configuration_dic_competence',
              libelle: 'Compétences',
              description: 'Gestion des compétences',
            },
            {
              route: 'configuration_dic_habilitation',
              libelle: 'Habilitations',
              description: 'Gestion des habilitations',
            },
            {
              route: 'configuration_dic_entretien_type',
              libelle: "Types d'entretien",
              description: "Gestion des types d'entretien",
            },
            {
              route: 'configuration_dic_type_fichier_admin',
              libelle: 'Types de fichier administratif',
              description: 'Gestion des types de fichier administratif',
            },
            {
              route: 'configuration_dic_type_echange',
              libelle: "Types d'échange",
              description: "Gestion des types d'échange",
            },
            {
              route: 'configuration_dic_type_absence',
              libelle: "Types d'absence",
              description: "Gestion des types d'absence",
            },
            {
              route: 'configuration_dic_type_contrat_remplacement',
              libelle: 'Types de contrat de remplacement',
              description: 'Gestion des types de contrat de remplacement',
            },
            {
              route: 'configuration_dic_periodicite',
              libelle: 'Périodicités',
              description: 'Gestion des périodicités',
            },
          ],
        },

        {
          blocks: [
            {
              route: '',
              libelle: 'Droits & permissions',
              description: 'Gestion des droits & permissions',
            },
            {
              route: 'parametre_user',
              libelle: 'Utilisateurs',
              description: 'Gestion des utilisateurs',
            },
          ],
        },
      ],
      title: 'Configuration - Dictionnaire',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
};
</script>

<style scoped></style>
